module.exports = "<story-list stories=\"vm.archives\"\n            on-select=\"vm.selectArchive(story, focusItem)\"\n            page-size=\"vm.pageSize\"\n            focus-item=\"vm.focusItem\"\n>\n</story-list>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/common/archives/archives.html
 ** module id = 213
 ** module chunks = 0
 **/